export const MIN_LENGTH = 'Below Min length';
export const MAX_LENGTH = 'Length limit exceeded';
export const DATE_PATTERN = 'Date is not valid';
export const MIN_AGE = 'Age less than 18';
export const SECURITY = 'Password doesn\'t match criteria';
export const REGEXP = 'Field doesn\'t match criteria';
export const EMPTY = 'Empty';
export const UNRECOGNIZED = 'Unrecognized Error';
